// src/components/modules/Dashboard.js

import React from "react";
import { useState } from "react";
import { useLocation } from "react-router-dom";
import { Tabs } from "antd";
import { IoIosCheckmarkCircle } from "react-icons/io";
import { HiLockClosed } from "react-icons/hi";
import { FaDatabase } from "react-icons/fa";
import Authentication from "../TabContent/Authentication";
import Migration from "../TabContent/Migration";
import Summary from "../TabContent/Summary";
import Mapping from "../TabContent/Mapping";
import { PiBoundingBoxFill } from "react-icons/pi";
import { useTab } from "../../context/TabContext";


const { TabPane } = Tabs;

export const Dashboard = () => {

  const { activeTab, setActiveTab } = useTab();

  const [count, setCount] = useState({
      orgsSourceCount: 0,
      groupsSourceCount: 0,
      agentsSourceCount: 0,
      usersSourceCount: 0,
      fieldsSourceCount: 0,
      ticketsSourceCount: 0,
      orgsDestinationCount: 0,
      groupsDestinationCount: 0,
      agentsDestinationCount: 0,
      usersDestinationCount: 0,
      fieldsDestinationCount: 0,
      ticketsDestinationCount: 0,
    });

  const isAuthenticationTabDisabled = activeTab !=="1";
  const isMigrationTabDisabled = activeTab !== "3";
  const isSummaryTabDisabled = activeTab !== "4"; 
  
  
  return (
    <div className="container mx-auto pt-16">
      <Tabs tabPosition="left" defaultActiveKey="1" activeKey={activeTab} onChange={setActiveTab}>
        <TabPane
          tab={
            <span className="flex items-center gap-2">
              <HiLockClosed style={{ fontSize: "20px" }} />{" "}
              <span className="text-[12px] relative top-[2px] tab-text">
                AUTHENTICATION
              </span>
            </span>
          }
          key="1"
          disabled={isAuthenticationTabDisabled}
        >
          <div className="tab-content">
            <div>
              <Authentication />
            </div>
          </div>
        </TabPane>
        {/* <TabPane tab={<span className="flex items-center gap-2"><PiBoundingBoxFill style={{fontSize:'20px'}} /> <span className="text-[12px] relative top-[2px] tab-text">MAPPING</span></span>}  key="2">
          <div className="tab-content">
              <div>
                 <Mapping />
              </div>
          </div>
        </TabPane> */}
        <TabPane
          tab={
            <span className="flex items-center gap-2">
              <FaDatabase style={{ fontSize: "16px" }} />{" "}
              <span className="text-[12px] relative top-[2px] tab-text">
                MIGRATION
              </span>
            </span>
          }
          key="3"
          disabled={isMigrationTabDisabled}
        >
          <div className="tab-content">
            <div>
              <Migration setCount={setCount} count={count}/>
            </div>
          </div>
        </TabPane>
        <TabPane
          tab={
            <span className="flex items-center gap-2">
              <IoIosCheckmarkCircle style={{ fontSize: "20px" }} />{" "}
              <span className="text-[12px] relative top-[2px] tab-text">
                SUMMARY
              </span>
            </span>
          }
          key="4"
          disabled={isSummaryTabDisabled}
        >
          <div className="tab-content">
            <div>
              <Summary count={count}/>
            </div>
          </div>
        </TabPane>
      </Tabs>
    </div>
  );
};
